import { useEffect } from "react";
import { useLogout } from "./useLogout";

export const AutoLogout = () => {
    const logout = useLogout();

    useEffect(() => {
        void logout();
    }, [logout]);

    return null;
};
